import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import EnvUI from "@/components/index";
import router from './router'
import global from "./global/config";
import axios from 'axios';
import "./styles/monitor.scss";
import { getRoutesLoaded, getMenuTree } from '@/views/home-view/menuTree.js'




Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(EnvUI);
Vue.use(global);



axios.interceptors.request.use(
  (config) => {
    let key = localStorage.getItem('cct-key')
    if (key) {
      config.headers.token = localStorage.getItem('cct-key')
    }
    return config
  },
  (err) => {
    return Promise.reject(err)
  }
)

// 响应拦截
axios.interceptors.response.use(
  function (response) {
    // 处理响应数据
    let code = response.data.code
    switch (code) {
      case 0:
        break
      case 401:
        localStorage.removeItem('cct-key')
        Vue.prototype.throttleMsg('账号会话已过期，请重新登录', 'warning', 3000)
        setTimeout(() => {
          router.push('/login')
        }, 2000)
        return false
      case 402:
        Vue.prototype.$message.warning('您不能操作此数据')
        break
      case 403:
        Vue.prototype.$message.warning('您没有权限访问')
        break
      case 500:
        Vue.prototype.throttleMsg('服务器连接超时', 'warning', 3000)
        break
      case 600:
        Vue.prototype.$message.warning('网络异常')
        break
      case undefined: // 因为有下载文件接口，直接返回文件的二进制，没有code
        break
      default:
        Vue.prototype.throttleMsg(response.data.message, 'warning')
        // return false
        break
    }
    return response;
  },
  function (error) {
    // 处理响应失败
    if (error.response.status === 500) {
      Vue.prototype.throttleMsg('服务器连接超时', 'warning', 5000)
    }
    return Promise.reject(error);
  }
);

router.beforeEach(async (to, from, next) => {
  if (to.path == "/forgot" || to.path == "/login") {
    next();
    return false;
  }
  let key = localStorage.getItem("cct-key");
  if (!key && to.path != "/login") {
    next({
      path: "/login",
    });
    return false;
  } else {

    // 实现刷新界面自动获取用户最新的菜单权限
    if (!getRoutesLoaded() && key) {
      await getMenuTree()

      const menu = JSON.parse(localStorage.getItem("cct-menu")).left;
      if (menu.length) {
        // 如果用户有菜单权限：直接跳转到对应界面
        next();
      } else {
        // 如果用户没有菜单权限：跳转到“暂无权限”界面
        next({
          path: "/emptyPermission",
        })
      }
    }
    if (to.matched.length === 0) {
      //如果未匹配到路由
      from.name
        ? next({
          name: from.name,
        })
        : next(to); //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    } else {
      next(); //如果匹配到正确跳转
    }
  }

})

axios.get("./config.json").then(res => {
  Vue.prototype.$config = res.data
  createApp()
})


function createApp() {
  new Vue({
    router,
    render: h => h(App),
  }).$mount('#app')
}
